import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Tabs } from "antd";

import Operator from "./Operator.js";
// import Business from "./Business.js";
import Agreement from "./Agreement.js";
import { VerificationAgreementWrapper } from './style.js'
import { checkInitialStatus } from "./Utils.js";

const TabPane = Tabs.TabPane;


const VerifyPage = ({ operatorStatusField, exchange, user }) => {

    const { BUSINESS_NAME, REGISTRATION_NUMBER, REGISTRATION_BUSINESS_ADDRESS, ADDRESS_LINE1, CITY, STATE, POSTCODE } = exchange && exchange[0] && exchange[0].info.biz;
    const statusState = user.id_data.status;
    const [activeTab, setActiveTab] = useState('0');
    const [verifyStatus, setVerifyStatus] = useState({ name: 0, phone: 0, identity: 0, business: 0, fileUpload: 0 });
    const businessStatus = BUSINESS_NAME && REGISTRATION_NUMBER && REGISTRATION_BUSINESS_ADDRESS && ADDRESS_LINE1 && CITY && STATE && POSTCODE ? 3 : 0;
    const handleBusinessComplete = (verifyStatus.business === 3 && verifyStatus.fileUpload === 3) ? 3 : (verifyStatus.business === 0 && verifyStatus.fileUpload === 0) ? 0 : 4;
    const handleOperatorComplete = (verifyStatus.name === 3 && verifyStatus.phone === 3 && verifyStatus.identity === 3) ? 3 : (verifyStatus.name === 0 && verifyStatus.phone === 0 && verifyStatus.identity === 0) ? 0 : 0;

    useEffect(() => {
        setVerifyStatus({ ...verifyStatus, name: checkInitialStatus(user.id_data.status === 3), phone: 3, identity: user.id_data.status || 0, business: businessStatus})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onHandleTab = (activeKey) => {
        setActiveTab(activeKey);
    }

    return (
        <VerificationAgreementWrapper>
            <div className="verify-agree-wrapper">
                <h2 className="title">Verification</h2>
                <Tabs defaultActiveKey={activeTab} activeKey={activeTab} onChange={onHandleTab}>
                    <TabPane tab="Operator" key="0">
                        <Operator
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            exchange={exchange}
                            statusState={statusState}
                            verifyStatus={verifyStatus}
                            setVerifyStatus={setVerifyStatus}
                            user={user}
                            operatorStatusField={operatorStatusField}
                            handleComplete={handleOperatorComplete}
                        />
                    </TabPane>
                    {/* <TabPane tab="Business" key="1">
                        <Business
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            exchange={exchange}
                            statusState={statusState}
                            verifyStatus={verifyStatus}
                            setVerifyStatus={setVerifyStatus}
                            handleComplete={handleBusinessComplete}
                        />
                    </TabPane> */}
                    <TabPane tab="Agreement" key="2">
                        <Agreement
                            activeTab={activeTab}
                            operatorStatusField={handleOperatorComplete}
                            businessStatusField={handleBusinessComplete}
                            setActiveTab={setActiveTab}
                            verifyStatus={verifyStatus}
                            setVerifyStatus={setVerifyStatus}
                            exchange={exchange}

                        />
                    </TabPane>
                </Tabs>
            </div>
        </VerificationAgreementWrapper>
    )
}

const mapStateToProps = (state) => {
    return {
        exchange: state.exchange,
        user: state.user
    }
}

export default connect(mapStateToProps)(VerifyPage);